import { KibsiClient } from './base';
/**
 * Client to make API calls to Kibsi services.
 * Implement per entity type by defining the REST paths. Or don't, up to you.
 */
export class KibsiCrudClient extends KibsiClient {
}
//# sourceMappingURL=crud-base.js.map